/**
 * Global Error Handler
 * Catches unhandled errors and promise rejections
 */

/**
 * Handle unhandled JavaScript errors
 */
export const setupGlobalErrorHandlers = () => {
  // Handle unhandled errors
  window.addEventListener('error', (event) => {
    console.error('Global error caught:', event.error);
    
    // Prevent default browser error handling
    event.preventDefault();
    
    // You can send error to logging service here
    // logErrorToService(event.error, {
    //   type: 'unhandled_error',
    //   filename: event.filename,
    //   lineno: event.lineno,
    //   colno: event.colno
    // });
  });

  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);
    
    // Prevent default browser error handling
    event.preventDefault();
    
    // You can send error to logging service here
    // logErrorToService(event.reason, {
    //   type: 'unhandled_promise_rejection'
    // });
  });

  // Handle React errors that escape ErrorBoundary
  const originalConsoleError = console.error;
  console.error = (...args) => {
    // Filter out known React warnings that aren't critical
    const message = args[0]?.toString() || '';
    if (
      message.includes('Warning:') &&
      !message.includes('Error:') &&
      !message.includes('Uncaught')
    ) {
      // This is just a warning, not a critical error
      originalConsoleError.apply(console, args);
      return;
    }
    
    // Log actual errors
    originalConsoleError.apply(console, args);
  };
};

/**
 * Log error to external service (optional)
 * Example: Sentry, LogRocket, etc.
 */
export const logErrorToService = (error, context = {}) => {
  // Example implementation (uncomment and configure as needed):
  /*
  if (window.Sentry) {
    window.Sentry.captureException(error, {
      extra: context
    });
  }
  */
  
  // For now, just log to console
  console.error('Error logged:', error, context);
};


